/*
 * Filename: SfConnector.ts
 * Description:Connects our app to salesforce
 */

import jsforce from 'jsforce';
import { IOAuthRequestOptions } from '../interfaces/IApp.interface';
import Cookies from 'universal-cookie';

export class SfConnector {
  private readonly cookie: Cookies;
  private readonly jsForce: any;
  private jsForceConnection: any;
  constructor() {
    this.cookie = new Cookies();
    this.jsForce = jsforce;
  }

  public login = async (oAuthRequestBody: IOAuthRequestOptions) => {
    return new Promise((resolve, reject) => {
      this.jsForce.browser.init({
        loginUrl: oAuthRequestBody.SF_OAUTH_LOGIN_URL,
        clientId: oAuthRequestBody.SF_CLIENT_ID,
        clientSecret: oAuthRequestBody.SF_CLIENT_SECRET,
        redirectUri: oAuthRequestBody.SF_REDIRECT_URL,
      });
      this.jsForce.browser.login({
        prompt: 'login consent',
      });
      return this.jsForce.browser.on('connect', (connection: jsforce.Connection) => {
        this.jsForceConnection = connection;
        if (connection) {
          let prefixName:any = localStorage.getItem('prefixName');
          localStorage.clear();
          if(prefixName){
            localStorage.setItem('prefixName', prefixName);
          }
          resolve(connection);
        } else {
          reject('Unable to connect to SF');
        }
      });
    });
  };

  logOut() {
    return new Promise<void>((resolve, reject) => {
      this.jsForce.browser.logout();
      this.jsForceConnection = null;
      this.jsForce.browser.on('disconnect', () => {
        resolve();
      });
    });
  } 
}
